import { Button, Drawer, Typography } from "antd";
import { AiOutlineArrowLeft, AiOutlineDownload } from "react-icons/ai";
import { isMobile } from "../../utils";
import { ReportTypeContainer } from "./styles";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";

interface IProps {
  open: boolean;
  loading?: boolean;
  setType: Function;
  onClose:
    | ((
        e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>
      ) => void)
    | undefined;
}

export const ReportTypeDrawer = ({
  open,
  loading,
  setType,
  onClose,
}: IProps) => {
  return (
    <Drawer
      open={open}
      placement="right"
      onClose={onClose}
      closeIcon={<AiOutlineArrowLeft />}
      title={
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          Voltar
        </div>
      }
      {...(isMobile() ? { width: "100%" } : { width: "420px" })}
    >
      <ReportTypeContainer>
        <div>
          <Typography.Title level={4}>Baixar</Typography.Title>
          <div className="divider" />
        </div>
        <div>
          <Typography.Text style={{ fontSize: "12px" }}>
          Qual tipo de arquivo deseja baixar?
          </Typography.Text>
        </div>
        <div className="textInfo">
          <InfoCircleOutlined style={{ marginTop: "5px" }} />
          <span>
            {" "}
            O arquivo baixado mostrará suas informações de acordo com os filtros
            selecionados no momento do download.
          </span>
        </div>
        <Button
          block
          size="large"
          type="ghost"
          disabled={loading}
          className="buttonDownload"
          onClick={() => setType("pdf")}
        >
          <AiOutlineDownload
            style={{
              width: "40px",
              height: "40px",
              marginRight: "4px",
              color: "var(--yellow)",
            }}
          />
          Arquivo em <b> PDF </b> para simples conferência de dados.
        </Button>
        <Button
          block
          size="large"
          type="ghost"
          onClick={() => setType("xlsx")}
          className="buttonDownload"
          disabled={loading}
        >
          <AiOutlineDownload
            style={{
              width: "40px",
              height: "40px",
              marginRight: "4px",
              color: "var(--yellow)",
            }}
          />
          Arquivo em <b> Excel </b> para ser importado em planilhas.
        </Button>
        {loading && (
          <LoadingOutlined
            style={{
              position: "absolute",
              top: "60%",
              left: "45%",
              color: "var(--ant-primary-color)",
            }}
          ></LoadingOutlined>
        )}
      </ReportTypeContainer>
    </Drawer>
  );
};
